import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { AssigneeCard, toAssigneeCardRecord } from "../assignee-card/assignee-card";
import { buildSuggestionInfoMap, lookupAssignee } from "../process-flow/core/builder";
import { resolveEntityRefDisplay } from "./suggestionNames";
import { ProposedEntityNameLabel } from "./ProposedEntityName";
/** A chip beside a field: the name and nothing else, whatever the model. */ const CHIP_VARIANTS = {
    User: "name-only",
    System: "name-only",
    OrgFunction: "name-only",
    ExternalContact: "name-only"
};
export function AssigneeDisplay({ assignedTo, assignedToModel, entitySuggestions, assigneeLookup, t, emptyLabel }) {
    // Built once per `entitySuggestions` identity (mirrors the sidebar's memoized
    // map) so a parent re-render doesn't rebuild the lookup on every pass.
    const suggestionInfoById = useMemo(()=>buildSuggestionInfoMap(entitySuggestions), [
        entitySuggestions
    ]);
    // `assignedTo` is an `EntityOrSuggestionRef`. A suggestion ref names a
    // proposed Team/System — show its proposed name (blue, or red once declined)
    // so it reads like the canvas placeholder. An empty slot and an unresolvable
    // suggestion both fall back to the neutral placeholder. Approval rewrites the
    // ref to `{ type: 'entity' }`, after which it renders as a card.
    const row = resolveEntityRefDisplay(assignedTo, {
        suggestionInfoById,
        pendingLabel: emptyLabel ?? `+ ${t("processFlow.editable.noAssignee")}`,
        getEntity: (id)=>lookupAssignee({
                type: "entity",
                id
            }, assignedToModel, assigneeLookup),
        t
    });
    switch(row.kind){
        case "proposed":
            return /*#__PURE__*/ _jsx(ProposedEntityNameLabel, {
                name: row.label,
                isDeclined: row.isDeclined,
                className: "text-sm"
            });
        case "pending":
            return /*#__PURE__*/ _jsx("span", {
                className: "text-fg-subtle italic text-sm",
                children: row.label
            });
        case "missing":
            // A missing entity falls back to the bare id so the row still renders
            // something.
            return /*#__PURE__*/ _jsx("span", {
                className: "text-fg-subtle text-sm",
                children: row.label
            });
        case "entity":
            break;
    }
    const record = toAssigneeCardRecord(assignedToModel, row.entity);
    if (!record) return null;
    return /*#__PURE__*/ _jsx(AssigneeCard, {
        record: record,
        variants: CHIP_VARIANTS,
        size: "sm",
        className: "p-0"
    });
}

//# sourceMappingURL=AssigneeDisplay.js.map